import { styled, Card, CardContent, Stack } from '@mui/material';

import { Button } from '../../../../components/atoms/Button';

export const DefaultCard = styled(Card)`
  position: relative;
  width: 100%;
  min-width: 100%;
  padding: 8px;
`;

export const StyledCardContent = styled(CardContent)((props: { isMobileView: boolean }) =>`
  background-color: white;
  padding: ${props.isMobileView ? '5px' : '15px'};
  border: gray 2px solid;
  border-radius: 5px;
`);

export const CardTitle = styled('p')`
  position: absolute;
  top: -22px;
  background-color: white;
  padding: 2px;
  font-size: 18px;
`;

export const CloseWrapper = styled('div')((props: { isMobileView: boolean }) => `
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  margin-top: ${props.isMobileView ? '-4px' : '7px'};
  margin-right: ${props.isMobileView ? '-4px' : '7px'};
  width: 35px;
  height: 35px;
  border-radius: 20px;
  color: gray;
  cursor: pointer;
  &:hover {
    background-color: #f5ebebff;
  }
`);

export const SHFDataWrapper = styled('div')`
  width: 100%;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 80px;
`;

export const SelectButton = styled(Button)`
  width: 100%;
  max-width: 150px;
`;

export const OuterWrapper = styled(Stack)`
  flex-direction: row-reverse;
  align-items: center;
`;

export const InnerWrapper = styled(Stack)((props: { isMobileView: boolean }) =>`
  direction: column;
  width: 100%;
  padding-top: 15px;
  padding-right: ${props.isMobileView ? '5px' : '15px'};
  margin-left: ${props.isMobileView ? '5px' : '0px'};
`);

export const CopyIconWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  cursor: pointer;
  &:hover {
    background-color: #eae8e8ff;
  }
`;